import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { useNavigate } from 'react-router-dom';
import MiningB from '../Main/image/채굴.png';
import TimeImage from "../Main/image/TimeB.png";
import DIcon from '../Main/image/Icon256.png'
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faSquareMinus } from '@fortawesome/free-solid-svg-icons';
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
import { toJS } from 'mobx';













function Mining() {
    const { loginStore } = useStore();
    // const { CoinStore } = useStore();
    const { MiningStore } = useStore();



    // const navigate = useNavigate();

    const useStyles = makeStyles((theme) => ({
        //Dialog
        Dialog: {
            width: '500px',
            height: "460px"
        },
        DialogMobile: {
            height: '65%',
            width: '80%',
            padding: '0',
            minWidth: "320px"
        },

    }));

    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");
    const isMiningButton = loginStore?.isMiningButton;




    const WhiteTextTypography = withStyles({
        root: {
            color: "#FFFFFF",
            fontSize: "1.5rem"

        }
    })(Typography);

    const TextTypography = withStyles({
        root: isMobile ?
            {
                fontSize: "0.6rem"
            }
            :
            {
                fontSize: "0.8rem"

            }
    })(Typography);

    const ReceiptTextTypography = withStyles({
        root: isMobile ?
            {
                fontSize: "1em"
            }
            :
            {
                fontSize: "1.2em"

            }
    })(Typography);



    const CloverTextTypography = withStyles({
        root: isMobile ?
            {
                color: "#f44336",
                fontSize: "0.8em",
            }
            :
            {
                color: "#f44336",
                fontSize: "1em",
            }
    })(Typography);


    const HistoryList = MiningStore?.MiningHistoryData;


    // const List = [
    //     {
    //         member_InOut: "IN",
    //         member_clover: "1000",
    //         count:"1",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },
    //     {
    //         member_InOut: "IN",
    //         member_D: "10",
    //         count:"20",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },{
    //         member_InOut: "OUT",
    //         member_D: "1200",
    //         count:"5",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },{
    //         member_InOut: "IN",
    //         member_clover: "10001",
    //         count:"10",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },{
    //         member_InOut: "OUT",
    //         member_D: "1",
    //         count:"12",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },{
    //         member_InOut: "IN",
    //         member_D: "23",
    //         count:"11",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },{
    //         member_InOut: "IN",
    //         member_clover: "10400",
    //         count:"32",
    //         reg_time: "2022-01-28T21:16:09.000Z"
    //     },{
    //         member_InOut: "OUT",
    //         member_D: "326423",
    //         count:"28",
    //         reg_time: "2022-01-14T21:16:09.000Z"
    //     },{
    //         member_InOut: "IN",
    //         member_D: "34534",
    //         count:"22",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },{
    //         member_InOut: "OUT",
    //         member_clover: "235",
    //         count:"45",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },{
    //         member_InOut: "IN",
    //         member_D: "547",
    //         count:"16",
    //         reg_time: "2022-01-18T21:16:09.000Z"
    //     },
    // ]

    const MiningUserMiningListData = toJS(MiningStore?.UserMiningListData);
    const Mined_second = MiningUserMiningListData?.mined_second;
    let Mined_second_hour = parseInt(Mined_second / 3600);
    let Mined_second_min = parseInt((Mined_second - (Mined_second_hour * 3600)) / 60);
    let Mined_second_sec = Mined_second - (Mined_second_hour * 3600) - (Mined_second_min * 60);


    const Remain_second = MiningUserMiningListData?.remain_second;
    let Remain_second_hour = parseInt(Remain_second / 3600);
    let Remain_second_min = parseInt((Mined_second - (Remain_second_hour * 3600)) / 60);
    let Remain_second_sec = Remain_second - (Remain_second_hour * 3600) - (Remain_second_min * 60);

    let MiningTime_hour = parseInt(MiningStore?.MiningTime / 3600);
    let MiningTime_min = parseInt((MiningStore?.MiningTime % 3600) / 60);
    let MiningTime_sec = MiningStore?.MiningTime % 60;


    // let NTime = new Date();
    // console.log("Time = ",NTime);
    // console.log("MiningUserMiningListData = ",MiningUserMiningListData);

    let Guide_clover_allPage_06 = loginStore?.Guide_clover_allPage_06; //회
    let Guide_clover_dialog_Mining_01 = loginStore?.Guide_clover_dialog_Mining_01; //채굴
    let Guide_clover_dialog_Mining_02 = loginStore?.Guide_clover_dialog_Mining_02; //시간
    let Guide_clover_dialog_Mining_03 = loginStore?.Guide_clover_dialog_Mining_03; //분
    let Guide_clover_dialog_Mining_04 = loginStore?.Guide_clover_dialog_Mining_04; //초
    let Guide_clover_dialog_Mining_05 = loginStore?.Guide_clover_dialog_Mining_05; //비용
    let Guide_clover_dialog_Mining_06 = loginStore?.Guide_clover_dialog_Mining_06; //진행 중
    let Guide_clover_dialog_Mining_07 = loginStore?.Guide_clover_dialog_Mining_07; //남은 정보
    let Guide_clover_dialog_Mining_08 = loginStore?.Guide_clover_dialog_Mining_08; //보유
    let Guide_clover_dialog_Mining_09 = loginStore?.Guide_clover_dialog_Mining_09; //채굴 정보
    let Guide_clover_dialog_Mining_11 = loginStore?.Guide_clover_dialog_Mining_11; //수령 가능
    let Guide_clover_dialog_Mining_12 = loginStore?.Guide_clover_dialog_Mining_12; //종류
    let Guide_clover_dialog_Mining_13 = loginStore?.Guide_clover_dialog_Mining_13; //수량
    let Guide_clover_dialog_Mining_14 = loginStore?.Guide_clover_dialog_Mining_14; //날짜
    let Guide_clover_dialog_Mining_button_01 = loginStore?.Guide_clover_dialog_Mining_button_01; //수령
    let Guide_clover_dialog_Mining_button_02 = loginStore?.Guide_clover_dialog_Mining_button_02; //내역
    let Guide_clover_dialog_Mining_button_03 = loginStore?.Guide_clover_dialog_Mining_button_03; //채굴시작
    let Guide_clover_dialog_Mining_button_04 = loginStore?.Guide_clover_dialog_Mining_button_04; //소요 시간



    return (
        <div>
            <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={loginStore?.isMiningDialogOpen} onClose={loginStore.setDialogClose()}>
                <Box sx={isMobile ? { display: 'flex', bgcolor: 'black', width: 'auto', maxWidth: '600px', height: '60px', } : { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', height: '70px', }}>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
                        <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                            <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                            <WhiteTextTypography >{Guide_clover_dialog_Mining_01}</WhiteTextTypography>
                        </Grid>
                        <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("MiningFalse") }} />
                        </Grid>
                    </Grid>
                </Box>
                <Box>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' paddingLeft="0px" position='sticky' top={0} >
                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4} >
                            <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                variant="contained" color='inherit' onClick={(e) => { loginStore.setDBMiningButton(0) }} >{Guide_clover_dialog_Mining_01}</Button>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4} >
                            <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                variant="contained" color='inherit' onClick={(e) => { loginStore.setDBMiningButton(1) }} >{Guide_clover_dialog_Mining_button_01}</Button>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4} >
                            <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                variant="contained" color='inherit' onClick={(e) => { loginStore.setDBMiningButton(2) }} >{Guide_clover_dialog_Mining_button_02}</Button>
                        </Grid>
                    </Grid>
                </Box>
                <DialogContent >
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column'>
                        {isMiningButton === 0 &&
                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8} >
                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' spacing={2} >
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop='20px'>
                                        <Box sx={isMobile ? { border: 1, margin: '0px', py: '10px', marginTop: '0px', borderRadius: "5px" } : { border: 1, mx: '5px', py: '10px', borderRadius: "5px" }}>
                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                                <Grid container item xs={3} sm={3} md={3} lg={3} xl={3} direction='row' alignItems='center' justifyContent='center' >
                                                    <Grid item xs={5} sm={5} md={5} lg={5} xl={5} >
                                                        <img src={MiningB} style={{ width: '90%', height: 'auto' }} alt='MiningB' />
                                                    </Grid>
                                                    <Grid >
                                                        <TextTypography>{MiningStore?.MiningCount}{Guide_clover_allPage_06}</TextTypography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} alignItems='center' justifyContent='center' >
                                                    <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} alignItems='center' justifyContent='flex-end' >
                                                        <TextTypography>{Guide_clover_dialog_Mining_button_04}</TextTypography>
                                                    </Grid>
                                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} alignItems='center' justifyContent='center' >
                                                        <img src={TimeImage} style={{ width: '60%', height: 'auto' }} alt='TimeImage' />
                                                    </Grid>
                                                    <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} alignItems='center' justifyContent='flex-start'>
                                                        <TextTypography>
                                                            {MiningTime_hour !== undefined ?
                                                                MiningTime_hour !== null ?
                                                                    MiningTime_hour !== 0 ?
                                                                        MiningTime_sec !== 0 ?
                                                                            MiningTime_hour + Guide_clover_dialog_Mining_02  + MiningTime_min +  Guide_clover_dialog_Mining_03  + MiningTime_sec + Guide_clover_dialog_Mining_04
                                                                            :
                                                                            MiningTime_hour +  Guide_clover_dialog_Mining_02  + MiningTime_min +  Guide_clover_dialog_Mining_03 
                                                                        :
                                                                        MiningTime_min +Guide_clover_dialog_Mining_03  + MiningTime_sec + Guide_clover_dialog_Mining_04
                                                                    :
                                                                    MiningTime_min +  Guide_clover_dialog_Mining_03  + MiningTime_sec + Guide_clover_dialog_Mining_04
                                                                :
                                                                MiningTime_min +  Guide_clover_dialog_Mining_03 + MiningTime_sec + Guide_clover_dialog_Mining_04}
                                                        </TextTypography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} alignItems='center' justifyContent='flex-end' >
                                                    <TextTypography>{Guide_clover_dialog_Mining_05}</TextTypography>
                                                    {/* <Grid item xs={1} sm={1} md={1} lg={1} xl={1} /> */}
                                                    <img src={CloverleafImage} style={{ width: '20%', height: 'auto' }} alt='CloverleafImage' />
                                                    <TextTypography>
                                                        {[MiningStore?.MiningCloverCount].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    </TextTypography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'grey.300', py: '10px', mx: '5%' }}>
                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                                                <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} direction='row' alignItems='center' justifyContent='flex-start'>
                                                    {/* <FontAwesomeIcon  icon={faSquarePlus}  size='xl' onClick={(e) => {MiningStore.setMiningCount("+")}} max={50} /> */}
                                                    <FontAwesomeIcon icon={faSquareMinus} size='xl' onClick={(e) => { MiningStore.setMiningCount("-") }} max={0} />
                                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
                                                    <Box sx={{ borderBottom: 1 }}>
                                                        <Typography>
                                                            {MiningStore?.MiningCount}
                                                        </Typography>
                                                    </Box>
                                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
                                                    <FontAwesomeIcon icon={faSquarePlus} size='xl' onClick={(e) => { MiningStore.setMiningCount("+") }} max={50} />
                                                    {/* <FontAwesomeIcon  icon={faSquareMinus}  size='xl' onClick={(e) => {MiningStore.setMiningCount("-")}} max={0} /> */}
                                                </Grid>
                                                <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} direction='row' alignItems='center' justifyContent='flex-end'>
                                                    <img src={CloverleafImage} style={{ width: '15%', height: 'auto' }} alt='CloverleafImage' />
                                                    <Grid container item xs={1} sm={1} md={1} lg={1} xl={1} />
                                                    <Typography>{[MiningStore?.MiningCloverCount].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                        <Box sx={{ borderBottom: 1, borderColor: 'grey.300', py: '10px', mx: '5%' }}>
                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                                                <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} direction='row' alignItems='center' justifyContent='center'>
                                                    {parseInt(MiningUserMiningListData?.remain_count) !== undefined || null ?
                                                        parseInt(MiningUserMiningListData?.remain_count) !== 0 ?
                                                            <TextTypography>{Guide_clover_dialog_Mining_06}</TextTypography>
                                                            :
                                                            <TextTypography>{Guide_clover_dialog_Mining_07}</TextTypography>
                                                        :
                                                        <TextTypography>{Guide_clover_dialog_Mining_07}</TextTypography>
                                                    }
                                                    <img src={MiningB} style={{ width: '20%', height: 'auto' }} alt='MiningB' />
                                                    <Typography>{MiningUserMiningListData.remain_count !== undefined || null ? MiningUserMiningListData.remain_count : "0"}{Guide_clover_allPage_06}</Typography>
                                                </Grid>
                                                <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} direction='row' alignItems='center' justifyContent='center'>
                                                    <Grid container item xs={1} sm={1} md={1} lg={1} xl={1} />
                                                    <TextTypography>{Guide_clover_dialog_Mining_08}</TextTypography>
                                                    <img src={CloverleafImage} style={{ width: '15%', height: 'auto' }} alt='CloverleafImage' />
                                                    <Grid container item xs={1} sm={1} md={1} lg={1} xl={1} />
                                                    <Typography>{[loginStore?.CloverCount].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop="-10px" >
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                            <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='center'>
                                                <CloverTextTypography>
                                                    {MiningStore?.MiningErrorMassage === "" ?
                                                        ""
                                                        :
                                                        MiningStore?.MiningErrorMassage
                                                    }
                                                </CloverTextTypography>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop={MiningStore.MiningErrorMassage ? "0px" : "10px"}>
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                            <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='center'>
                                                <Button variant="contained" color='inherit' style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20, }}
                                                    onClick={(e) => { MiningStore.getStandMining(e) }}>
                                                    {Guide_clover_dialog_Mining_button_03}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* </Box> */}
                            </Grid>
                        }
                        {isMiningButton === 1 &&
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' spacing={2} >
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop='10px'>
                                    <Box sx={{ borderTop: 1, borderColor: 'grey.300', py: '10px', mx: 'full', my: "-2%" }} />
                                    <Typography>
                                        {Guide_clover_dialog_Mining_09}
                                    </Typography>
                                    <Box sx={isMobile ? { border: 1, margin: '0px', py: '10px', marginTop: '0px', borderRadius: "5px" } : { border: 1, mx: '5px', py: '10px', borderRadius: "5px" }}>
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                            <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} direction='row' alignItems='center' justifyContent='flex-start' >
                                                <img src={MiningB} style={{ width: '15%', height: 'auto' }} alt='MiningB' />
                                                <TextTypography>{MiningUserMiningListData?.mined_stand !== undefined || null ? MiningUserMiningListData.mined_stand : ".00000000.000000000"}</TextTypography>
                                            </Grid>
                                            <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' alignItems='center' justifyContent='center' >
                                                <Grid container item xs={3} sm={3} md={3} lg={3} xl={3} alignItems='center' justifyContent='center' >
                                                    <img src={TimeImage} style={{ width: '60%', height: 'auto' }} alt='TimeImage' />
                                                </Grid>
                                                <Grid container item xs={9} sm={9} md={9} lg={9} xl={9} alignItems='center' justifyContent='flex-start' >
                                                    <TextTypography>
                                                        {
                                                            MiningUserMiningListData?.mined_second !== undefined || null ?
                                                                Mined_second_hour !== 0 ?
                                                                    Number.isNaN(MiningUserMiningListData?.mined_second) ?
                                                                        "0"
                                                                        :
                                                                        Mined_second_hour + Guide_clover_dialog_Mining_02  + Mined_second_min +  Guide_clover_dialog_Mining_03  + Mined_second_sec
                                                                    :
                                                                    Mined_second_min +  Guide_clover_dialog_Mining_03  + Mined_second_sec : "0"}
                                                        {Guide_clover_dialog_Mining_04}
                                                    </TextTypography>
                                                </Grid>
                                            </Grid>
                                            <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} alignItems='center' justifyContent='center' >
                                                <TextTypography>
                                                    {MiningUserMiningListData?.mined_count !== undefined || null ?
                                                        MiningUserMiningListData?.mined_count
                                                        :
                                                        "0"}
                                                    {Guide_clover_allPage_06}
                                                </TextTypography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <Typography>
                                        {Guide_clover_dialog_Mining_07}
                                    </Typography>
                                    <Box sx={isMobile ? { border: 1, margin: '0px', py: '10px', marginTop: '0px', borderRadius: "5px" } : { border: 1, mx: '5px', py: '10px', borderRadius: "5px" }}>
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                            <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='center' >
                                                <TextTypography>{MiningUserMiningListData?.remain_count !== undefined || null ? MiningUserMiningListData.remain_count : "0"}{Guide_clover_allPage_06}</TextTypography>
                                            </Grid>
                                            <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} alignItems='center' justifyContent='center' >
                                                <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} alignItems='center' justifyContent='center' >
                                                    <img src={TimeImage} style={{ width: '60%', height: 'auto' }} alt='TimeImage' />
                                                </Grid>
                                                <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} alignItems='center' justifyContent='flex-start'>
                                                    <TextTypography>{MiningUserMiningListData?.remain_second !== undefined || null ?
                                                        MiningStore?.RemainSecondHour !== 0 ?
                                                            Number.isNaN(Remain_second_sec) ?
                                                                "0"
                                                                :
                                                                MiningStore?.RemainSecondHour +  Guide_clover_dialog_Mining_02  + MiningStore?.RemainSecondMin +  Guide_clover_dialog_Mining_03  + MiningStore?.RemainSecondSec
                                                            :
                                                            MiningStore?.RemainSecondMin +  Guide_clover_dialog_Mining_03  + MiningStore?.RemainSecondSec
                                                        :
                                                        "0"}{Guide_clover_dialog_Mining_04}</TextTypography>
                                                </Grid>
                                            </Grid>
                                            <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} alignItems='center' justifyContent='flex-start' >
                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
                                                <img src={CloverleafImage} style={{ width: '30%', height: 'auto' }} alt='CloverleafImage' />
                                                <TextTypography>
                                                    {
                                                        MiningUserMiningListData?.remain_clover !== undefined || null ?
                                                            [MiningUserMiningListData?.remain_clover].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                                            :
                                                            "0"
                                                    }
                                                </TextTypography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                    <Box sx={{ borderTop: 1, borderColor: 'grey.300', py: '10px', mx: '5%' }}>
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                                            <ReceiptTextTypography>{Guide_clover_dialog_Mining_11}:</ReceiptTextTypography>
                                            <img src={MiningB} style={{ width: '10%', height: 'auto' }} alt='MiningB' />
                                            <ReceiptTextTypography>
                                                {MiningUserMiningListData?.mined_stand !== undefined || null || 0 ?
                                                    MiningUserMiningListData?.mined_stand :
                                                    ".00000000.000000000"
                                                }
                                            </ReceiptTextTypography>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                        <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='center'>
                                            <Button variant="contained" color='inherit' style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }} onClick={(e) => { MiningStore.getUserMiningComplete() }}>
                                                {Guide_clover_dialog_Mining_button_01}
                                            </Button>
                                        </Grid>
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {isMiningButton === 2 &&
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' spacing={2} >
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop='20px'>
                                    <Box sx={{ borderTop: 1, borderColor: 'grey.300', py: '10px', mx: 'full', my: "-4%" }} />
                                    <Box sx={isMobile ? { border: 1, margin: '0px', py: '10px', marginTop: '0px', borderRadius: "5px", borderColor: 'grey.400', overflow: 'scroll' } : { border: 1, mx: '5px', py: '10px', borderRadius: "5px", borderColor: 'grey.400', overflow: 'scroll' }}>
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                            <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='center' >
                                                <TextTypography>{Guide_clover_dialog_Mining_12}</TextTypography>
                                            </Grid>
                                            <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='center'   >
                                                <Grid container item xs={3} sm={3} md={3} lg={3} xl={3} alignItems='center' justifyContent='center'   >
                                                    <img src={MiningB} style={{ width: '200%', height: 'auto' }} alt='MiningB' />
                                                </Grid>
                                                <Grid container item xs={9} sm={9} md={9} lg={9} xl={9} alignItems='center' justifyContent='flex-start' paddingLeft="5%" >
                                                    <TextTypography>{Guide_clover_dialog_Mining_13}</TextTypography>
                                                </Grid>
                                            </Grid>
                                            <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' alignItems='center' justifyContent='center'   >
                                                <Grid container item xs={3} sm={3} md={3} lg={3} xl={3} alignItems='center' justifyContent='flex-end'   >
                                                    <FontAwesomeIcon icon={faCalendarDays} />
                                                </Grid>
                                                <Grid container item xs={9} sm={9} md={9} lg={9} xl={9} alignItems='center' justifyContent='flex-start' paddingLeft="5%" >
                                                    <TextTypography>{Guide_clover_dialog_Mining_14}</TextTypography>
                                                </Grid>
                                            </Grid>
                                            <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' alignItems='center' justifyContent='center'   >
                                                <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} alignItems='center' justifyContent='flex-end'   >
                                                    <img src={CloverleafImage} style={{ width: '40%', height: 'auto' }} alt='CloverleafImage' />
                                                </Grid>
                                                <Grid item>
                                                    /
                                                </Grid>
                                                <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} alignItems='center' justifyContent='flex-start'  >
                                                    <img src={DIcon} style={{ width: '40%', height: 'auto' }} alt='CloverleafImage' />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} sx={{ marginTop: -2 }}>
                                    <Box sx={isMobile ? { border: 1, margin: '0px', py: '10px', marginTop: '0px', borderRadius: "5px", borderColor: 'grey.400', height: '250px' } : { border: 1, mx: '5px', py: 'auto', borderRadius: "5px", borderColor: 'grey.400', height: '250px' }} overflow='scroll'>
                                        {HistoryList?.map((list) => (
                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' key={list.event_time} marginY="2%">
                                                <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='center' >
                                                    {list?.event_type === -1 ?
                                                        <FontAwesomeIcon icon={faRotate} />
                                                        :
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    }
                                                </Grid>
                                                <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='center' >
                                                    <TextTypography>
                                                        {list?.stand_value}
                                                    </TextTypography>
                                                </Grid>
                                                <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' alignItems='center' justifyContent='center' >
                                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} alignItems='center' justifyContent='flex-end'   >
                                                    </Grid>
                                                    <Grid container item xs={10} sm={10} md={10} lg={10} xl={10} alignItems='center' justifyContent='flex-start' paddingLeft="5%" >
                                                        <TextTypography>
                                                            {list?.event_time.split("T")[0]}
                                                        </TextTypography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} direction='row' alignItems='center' justifyContent='center' >
                                                    {list?.event_type === 1 ?
                                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center'  >
                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} />
                                                            <Grid container item xs={9} sm={9} md={9} lg={9} xl={9} direction='row' alignItems='center' justifyContent='flex-start'>
                                                                <img src={CloverleafImage} style={{ width: '10%', height: 'auto' }} alt='CloverleafImage' />
                                                                <TextTypography>{[list?.event_value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TextTypography>
                                                            </Grid>
                                                        </Grid>
                                                        :
                                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} alignItems='center' justifyContent='center'   >
                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} />
                                                            <Grid container item xs={9} sm={9} md={9} lg={9} xl={9} direction='row' alignItems='center' justifyContent='flex-start'>
                                                                <img src={DIcon} style={{ width: '10%', height: 'auto' }} alt='DIcon' />
                                                                <TextTypography>
                                                                    {[list?.event_value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                                </TextTypography>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                    {/* {list.member_D && 
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} alignItems='center'  justifyContent='center'   >
                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3} />
                                        <Grid container item xs={9} sm={9} md={9} lg={9} xl={9}  direction='row' alignItems='center'  justifyContent='flex-start'>
                                            <img src={DIcon} style={{width:'10%', height:'auto' }} alt='DIcon' />
                                            <TextTypography>
                                                {[list.member_D].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            </TextTypography>
                                        </Grid>
                                    </Grid>
                                    } */}
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Box>
                                </Grid>
                            </Grid>
                        }
                    </Grid>

                </DialogContent>
            </Dialog>
        </div>
    );
};

export default observer(Mining);
